import { Flame } from "lucide-react";

// Real count of inquiries in the last 7 days — hidden below 2 so it never looks manufactured.
export default function EnquiryBadge({ count, slug, variant = "card" }) {
  if (!count || count < 2) return null;

  const light = variant === "hero";
  return (
    <span
      data-testid={`enquiry-badge-${slug}`}
      className={`inline-flex items-center gap-2 rounded-full px-3.5 py-1.5 text-xs tracking-wide ${
        light
          ? "bg-[#FAF6F0]/15 text-[#FAF6F0] ring-1 ring-[#FAF6F0]/30 backdrop-blur"
          : "bg-[#A6521B]/12 text-[#A6521B] mb-3"
      }`}
    >
      <Flame size={13} className="flex-shrink-0" />
      {count} {count === 1 ? "person" : "people"} enquired this week
    </span>
  );
}
